export default {
    "displayCompany": 'sort',
    "displayPricing": false,      
    "displayAlternatives": false,
    "displayProposals": false,
    "displayChips": false,
    "showMaterialCatalog": false,
    "showOnlyActivated": false,
    "displayCatalogFiltering": true, 
    "selectedCatalogType": 'all',    
    "hideNews": false,
    "theme": "orange",
    "itemView": "gallery",
    "thumbnailSize": 90,
    "favorite": [],
    "hiddenCatalogs": [],
    "selectedCatalogs": [],
    "selectedGroup": {},
    "selectedTab": '',
    "previousSearch": [],
    "openedGroup": false,
    "baseUrl": '',
    
    "conf_optionView": "gallery",
    "conf_unionOption": "union",
    "conf_thumbnailSize": 90,
    "conf_baseUrl": "",
    "locale": "en-us",

    "conf_thumbnailSize_style": 90,
    "conf_optionView_style": "gallery",
    "conf_thumbnailSize_subItem": 90,
    "conf_optionView_subItem": "list",
    "conf_thumbnailSize_light": 90,
    "conf_optionView_light": "gallery",

    "hideLightTab": true,
    "enable_contextualHelp": true,
    "enable_optionProposals": false,
    "loaderColor": '#6038E8'
}
